import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "wc-payment-badges"
}

import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { PAYMENT_METHOD_TYPES } from '@/constants/AppConstants';
import ItemDetail from '@/models/entities/items/item-detail';
import WebPaymentMethod from '@/models/entities/items/web-payment-method';
import WCPaymentOptionBadgeModernCard from '../WCPaymentOptionBadgeModernCard/WCPaymentOptionBadgeModernCard.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'WCPaymentOptionBadgesModernCard',
  props: {
    item: {},
    ebtOnly: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const { t } = useI18n();

const getTenderLabel = (specialTender: WebPaymentMethod): string => {
  if (specialTender.tenderType === PAYMENT_METHOD_TYPES.EBT_SNAP) {
    return t('ebtSnap');
  }
  if (specialTender.tenderType === PAYMENT_METHOD_TYPES.EBT_CASH_BENEFITS) {
    return t('ebtCashLabel');
  }
  return specialTender.name || '';
};

const displayableOptions = computed(() => {
  let specialTenders = props.item.specialTenders;
  if (props.ebtOnly) {
    specialTenders = specialTenders?.filter(
      specialTender =>
        specialTender.tenderType === PAYMENT_METHOD_TYPES.EBT_SNAP ||
        specialTender.tenderType === PAYMENT_METHOD_TYPES.EBT_CASH_BENEFITS,
    );
  }
  return specialTenders
    ?.map(specialTender => ({ ...specialTender, label: getTenderLabel(specialTender) }))
    .sort((a, b) => (a.label ?? '').localeCompare(b.label ?? ''));
});

return (_ctx: any,_cache: any) => {
  return (displayableOptions.value?.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayableOptions.value, (paymentOption) => {
          return (_openBlock(), _createBlock(WCPaymentOptionBadgeModernCard, {
            key: paymentOption.id,
            paymentOption: paymentOption
          }, null, 8, ["paymentOption"]))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}
}

})